// extracted by mini-css-extract-plugin
export var appear = "styles-module--appear--iwDTB";
export var appearDown = "styles-module--appear-down--GFmxz";
export var appearLeft = "styles-module--appear-left--fUsxL";
export var appearRight = "styles-module--appear-right--2hD8e";
export var appearUp = "styles-module--appear-up--aKt7G";
export var container = "styles-module--container--18U8t";
export var content = "styles-module--content--Jp4g6";
export var preview = "styles-module--preview--jpbIm";
export var sidebar = "styles-module--sidebar--dVQqY";